import { BasicInformationPage } from './BasicInformationPage';
import { JobDescriptionPage } from './JobDescriptionPage';
import { ReviewAndPaymentPage } from './ReviewAndPaymentPage';
import { WorkDetailsPage } from './WorkDetailsPage';

export * from './CreatePermanentJobsPage';
export * from './Types';

export const CreatePermanentJobPosting = {
  BasicInformationPage,
  JobDescriptionPage,
  ReviewAndPaymentPage,
  WorkDetailsPage,
};
